import React from 'react';
import { Row } from 'reactstrap';
import BoldButton from '../../Common/BoldButton';
import OrderTransactionDto from '../../Common/dtos/OrderTransactionDto';
import { OrderTransactionView } from './OrderTransactionView';

interface IProps {
  orderTransaction: OrderTransactionDto,
  backClicked: () => void
  handleVoidSuccess: () => void;
}

const SingleOrderTransactionPage = (props: IProps) => {
  const { orderTransaction } = props;

  return <>
    <h2 className="col-auto ka-blue">Order Transactions</h2>
    <Row className="justify-content-between mb-2">
      <BoldButton className="col-auto btn-ghost-secondary" variant="link" onClick={props.backClicked}>
        <i className="bi-chevron-left" /> Back
      </BoldButton>
    </Row>
    <Row>
      <div>
        <OrderTransactionView orderTransaction={orderTransaction} key={`orderTransaction-${orderTransaction.id}`} handleVoidSuccess={props.handleVoidSuccess}/>
      </div>
    </Row>
  </>
}

export { SingleOrderTransactionPage };
